<template>
  <div :class="[$style.container, { [$style.block]: block }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'base-box',

  props: {
    block: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" module>
.container {
  border-radius: $radius-medium;
  background: $color-light;
  padding: spacing(3) spacing(1);
  width: 100%;
  box-shadow: $shadow-small;
  text-align: center;
  margin: 0 auto;
  max-width: 382px;

  @include wider-than(390px) {
    padding: spacing(3) spacing(3);
  }
}

.block {
  margin-left: 0;
  margin-right: 0;
  text-align: left;
  max-width: initial;
}
</style>
